import React, { useState, useEffect, useContext } from 'react';
import { Typography, Button, Box } from '@mui/material';
import {
  Home,
  Build,
  Description,
  Receipt,
  Payment,
  Logout,
  Settings,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import DashboardLayout from '../../components/DashboardLayout';
import axios from '../../api/client';
import PropertyDetails from '../../components/tenant/PropertyDetails';
import RepairRequests from '../../components/tenant/RepairRequests';
import Notices from '../../components/tenant/Notices';
import RentIncreases from '../../components/tenant/RentIncreases';
import Invoices from '../../components/tenant/Invoices';
import PaymentSubmission from '../../components/tenant/PaymentSubmission';
import UserSettings from '../../components/UserSettings';

const TenantDashboard = () => {
  const [tabValue, setTabValue] = useState(0);
  const [property, setProperty] = useState(null);
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProperty();
  }, []);

  const fetchProperty = async () => {
    try {
      const response = await axios.get('/properties');
      if (response.data && response.data.length > 0) {
        setProperty(response.data[0]);
      }
    } catch (error) {
      console.error('Error fetching property:', error);
    }
  };

  // Wait for the cookie to actually be cleared before leaving, and replace the history
  // entry so Back from the login screen does not step into the signed-out dashboard.
  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  // Bind propertyId-dependent tabs here since DashboardLayout's nav items don't
  // otherwise carry per-render props.
  const navItems = [
    { icon: <Home />, label: 'Property Details', Component: () => <PropertyDetails property={property} /> },
    { icon: <Build />, label: 'Repair Requests', Component: () => <RepairRequests propertyId={property?._id} /> },
    { icon: <Description />, label: 'Notices', Component: () => <Notices propertyId={property?._id} /> },
    { icon: <Receipt />, label: 'Rent Increases', Component: RentIncreases },
    { icon: <Receipt />, label: 'Invoices', Component: Invoices },
    { icon: <Payment />, label: 'Payments', Component: PaymentSubmission },
    { icon: <Settings />, label: 'Settings', Component: UserSettings },
  ];

  return (
    <DashboardLayout
      title="Tenant Portal"
      navItems={navItems}
      activeIndex={tabValue}
      onSelect={setTabValue}
      headerActions={
        <>
          <Typography variant="body2" sx={{ mr: 2, display: { xs: 'none', sm: 'block' } }}>
            {user?.name}
          </Typography>
          <Button color="inherit" onClick={handleLogout} startIcon={<Logout />} sx={{ minWidth: 0, px: { xs: 1, sm: 2 } }}>
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>Logout</Box>
          </Button>
        </>
      }
    />
  );
};

export default TenantDashboard;

